/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { BasicDigitalFarmerAccount } from '../../azure-b2c/storage';

export const isDigitalFarmerAccount = (
  option: string | BasicDigitalFarmerAccount,
): option is BasicDigitalFarmerAccount => {
  return typeof option === 'object' && 'accountNumber' in option;
};

export const getAccountName = (option: string | BasicDigitalFarmerAccount): string => {
  if (isDigitalFarmerAccount(option)) {
    return option.accountName;
  }
  return option;
};
